import React from "react";

const AGE_CATS = ["U7", "U9", "U11", "U13", "U15", "U17", "U18", "Senior", "Vétéran"];
const COLORS = ["Bleu", "Blanc", "Rouge", "Noir", "Vert", "Jaune", "Orange", "Violet", "Rose", "Gris"];

export default function ClubTeamsAndColors({ f, setF }) {
    const toggleColor = (v) => setF((x) => ({
        ...x, colors: x.colors.includes(v) ? x.colors.filter((y) => y !== v) : [...x.colors, v],
    }));
    const toggleAge = (cat) => setF((x) => {
        const exists = x.teams_by_category.find((t) => t.age_category === cat);
        return {
            ...x,
            teams_by_category: exists
                ? x.teams_by_category.filter((t) => t.age_category !== cat)
                : [...x.teams_by_category, { age_category: cat, num_teams: 1, players_per_team: 12 }],
        };
    });
    const updateTeam = (cat, field, value) => setF((x) => ({
        ...x,
        teams_by_category: x.teams_by_category.map((t) =>
            t.age_category === cat ? { ...t, [field]: Math.max(0, +value || 0) } : t
        ),
    }));

    return (
        <>
            <div>
                <label className="label-tu">Catégories d'âge & effectifs</label>
                <div className="flex flex-wrap gap-2 mb-4">
                    {AGE_CATS.map((c) => {
                        const active = !!f.teams_by_category.find((t) => t.age_category === c);
                        return (
                            <button type="button" key={c} onClick={() => toggleAge(c)}
                                className={[
                                    "px-3 py-1.5 text-xs uppercase tracking-wider border transition-colors",
                                    active ? "border-orange-500 text-orange-500 bg-orange-500/10"
                                        : "border-zinc-800 text-zinc-300 hover:border-zinc-600",
                                ].join(" ")}>{c}</button>
                        );
                    })}
                </div>
                {f.teams_by_category.length > 0 && (
                    <div className="space-y-2 border border-zinc-800 bg-zinc-950 p-4">
                        {f.teams_by_category.map((t) => (
                            <div key={t.age_category} className="grid grid-cols-12 gap-2 items-center">
                                <div className="col-span-4 font-bold">{t.age_category}</div>
                                <input type="number" min={1} value={t.num_teams}
                                    onChange={(e) => updateTeam(t.age_category, "num_teams", e.target.value)}
                                    className="input-tu col-span-4 py-2" placeholder="Équipes" />
                                <input type="number" min={1} value={t.players_per_team}
                                    onChange={(e) => updateTeam(t.age_category, "players_per_team", e.target.value)}
                                    className="input-tu col-span-4 py-2" placeholder="Joueurs/équipe" />
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div>
                <label className="label-tu">Couleurs</label>
                <div className="flex flex-wrap gap-2">
                    {COLORS.map((c) => (
                        <button type="button" key={c} onClick={() => toggleColor(c)}
                            className={[
                                "px-3 py-1.5 text-xs uppercase tracking-wider border transition-colors",
                                f.colors.includes(c) ? "border-orange-500 text-orange-500 bg-orange-500/10"
                                    : "border-zinc-800 text-zinc-300 hover:border-zinc-600",
                            ].join(" ")}>{c}</button>
                    ))}
                </div>
            </div>
        </>
    );
}
